<template>

    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-3 g-lg- mb-5">
        <div class="col" v-for="product in visitedProducts">
            <product :product="product" />
        </div>
    </div>

</template>


<script>
    import Product from '@/shared/Product';

    export default {
        props: [
        ],
        data() {
            return {
                visitedProducts: this.$page.props.shop.visitedProducts
            }
        },
        components: {
            Product,
        },
    }
</script>